import React from 'react';
import path from 'path';
import { promises as fs } from 'fs';
import { CurrentItemPage } from '../../components/Views/CurrentItemPage';
import Layout from '../../components/Layout/Layout';
import { makeHostSum, normalizePath } from '../../utils/helpers';
import { getStaticData } from '../../utils/helpers/getStaticData';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import {
  getCurrentItemData,
  normalizeItemPagePath
} from '../../utils/helpers/item';
import { getDeviceType } from '../../utils/helpers/getDeviceType';
import { generateItemSeoObj } from '../../utils/helpers/seo';
import { resolveCurrentItemMockFile } from '../../utils/helpers/resolveCurrentItemMockFile';

const CurrentItem = props => <CurrentItemPage {...props} />;

const getCurrentItemMockData = async (params, query) => {
  const filePath = resolveCurrentItemMockFile(params.id, query);
  const currentData = path.join(
    process.cwd(),
    'cypress/mock/current_item',
    filePath
  );

  const file = await fs.readFile(currentData, 'utf-8');
  const raw = JSON.parse(file);
  return params.id === '3878205'
    ? {
        ...raw,
        data: {
          ...raw.data,
          item: {
            ...raw.data.item,
            isAuthor: false,
            isMine: false
          }
        }
      }
    : raw;
};

export async function getServerSideProps({ res, req, params, query }) {
  const { deviceType, device } = getDeviceType(req.headers['user-agent']);
  const lang = getLocaleOnSSR(req);

  if (query.mock === 'true' && process.env.NODE_ENV !== 'production') {
    const mock = await getCurrentItemMockData(params, query);
    return {
      props: {
        currentItemData: mock.data.item,
        deviceType,
        device,
        mainPageImage: mock.data.item?.photos[0] || {}
      }
    };
  }
  const apolloClient = initApollo({}, { lang, headers: req.headers });

  const currentAsPath = normalizeItemPagePath(req.url);
  const newAsPath = normalizePath(currentAsPath);
  const hostSum = makeHostSum({ asPath: newAsPath, req });

  const show404Page = response => {
    response.statusCode = 404;
    return { props: { statusCode: 404 } };
  };

  if (res && !currentAsPath.match(/\d+/)?.[0]) return show404Page(res);

  const [staticData, currentItemRes] = await Promise.all([
    getStaticData(apolloClient),
    getCurrentItemData(apolloClient, params.id)
  ]);

  const { currentItemData } = currentItemRes;
  const seoData = generateItemSeoObj(currentItemData, newAsPath, hostSum);

  if (!currentItemData) res.statusCode = 404;

  return {
    props: {
      newAsPath,
      hostSum,
      deviceType,
      device,
      seoData,
      mainPageImage: currentItemData?.photos[0] || {},
      ...staticData,
      ...currentItemRes
    }
  };
}

CurrentItem.getLayout = (page, pageProps) => (
  <Layout
    isSafeAreaTop
    isBottomNavigation={false}
    isCurrentItemPage
    isBanner
    pageProps={pageProps}
    isBackgroundBanner
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default CurrentItem;
